export const AuthCompromis = ({ auth, handleChange, error, enguany, anyVinent }) => {
  return (<>
  <div className="row">
    <div className="col col-12 ">
      <h4>
      Carta de compromís educatiu: Alumnat amb 16 anys complerts. Curs {enguany}-{anyVinent}
      </h4>

      <p>Conscients que l’educació dels joves implica l’acció conjunta de la família i de l’institut, signem aquesta carta de compromís educatiu, la qual comporta els següents COMPROMISOS:</p>

      <h5>
      Per part del centre:
      </h5>

        <ol>
          <li>Proporcionar una formació que contribueixi al desenvolupament integral de la personalitat de l’alumne/a.</li>
          <li>Fer respectar els drets de l’alumne/a en l’àmbit escolar.</li>
          <li>Educar en la línia del respecte a un mateix, el respecte als altres i el respecte a l’entorn.</li>
          <li>Informar la família del projecte educatiu i de les normes d’organització i funcionament del centre.</li>
          <li>Informar la família i l’alumne/a dels criteris que s’aplicaran per avaluar el rendiment acadèmic, fer-ne una valoració objectiva i, si escau, explicar a la família els resultats de les avaluacions.</li>
          <li>Adoptar les mesures educatives alternatives o complementàries adients, dins les possibilitats del centre, per atendre les necessitats específiques de l’alumne/a i mantenir-ne informada la família.</li>
          <li>Mantenir comunicació regular amb la família per informar-la de l’evolució acadèmica personal de l’alumne/a.</li>
          <li>Comunicar a la família les absències no justificades de l’alumne/a al centre, i qualsevol altra circumstància que sigui rellevant per al seu desenvolupament acadèmic i personal.</li>
          <li>Atendre en un termini raonable les peticions d’entrevista o de comunicació que formuli la família.</li>
          <li>Revisar periòdicament l’evolució de l’alumne/a i, si escau, proposar mesures alternatives a la permanència en l’institut o, fins i tot, la seva sortida.</li>
          <li>Revisar conjuntament amb la família el compliment d’aquests compromisos i, si escau, el seu contingut.</li>
        </ol>

      <h5>
      Per part de la família:
      </h5>

        <ol>

          <li>Respectar el caràcter propi del centre i reconèixer l’autoritat del professorat i la de l’equip directiu.</li>
          <li>Compartir amb el centre l’educació del fill/a i desenvolupar i afavorir les complicitats que són necessàries per aplicar el projecte educatiu del centre.</li>
          <li>Instar el fill o filla a respectar les normes específiques de funcionament del centre, en particular, les que afecten a la convivència escolar i el desenvolupament normal de les classes.</li>
          <li>Acceptar l’establiment de mesures correctores en cas d’incompliment tal i com figuren a les normes d’organització i funcionament del centre.</li>
          <li>Vetllar perquè el fill/a compleixi el deure bàsic de l’estudi i de l’assistència regular i puntual a les activitats acadèmiques, i també perquè faci les tasques encomanades a casa pel professorat.</li>
          <li>Ajudar el nostre fill o filla a organitzar el temps d’estudi a casa i a preparar el material per a l’activitat escolar.  També haurem de procurar que tingui sempre el material escolar necessari pel treball a l’Institut.</li>
          <li>Adoptar criteris i mesures que puguin afavorir el rendiment escolar del fill o filla.</li>
          <li>Adreçar-se directament al centre per contrastar les discrepàncies, coincidències o suggeriments en relació amb l’aplicació del projecte educatiu en la formació del fill o filla.</li>
          <li>Facilitar al centre les informacions del fill o filla que siguin rellevants per al procés d’aprenentatge.</li>
          <li>Atendre les peticions d’entrevista o de comunicació que formuli el centre.</li>
          <li>Signar la baixa del fill/a del centre si, o bé no hi ha evolució en el procés d’ensenyament-aprenentatge del fill/a, o bé aquesta evolució no és positiva.</li>
          <li>Informar el fill o filla del contingut d’aquests compromisos.</li>

        </ol>


      <h5>
      Per part de l'alumne:
      </h5>

        <ol>

          <li>Respectar el caràcter propi del centre i reconèixer l’autoritat del professorat i la de l’equip directiu.</li>
          <li>Respectar les normes específiques de funcionament del centre, en particular, les que afecten a la convivència escolar i el desenvolupament normal de les classes.</li>
          <li>Acceptar l’establiment de mesures correctores en cas d’incompliment tal i com figuren a les normes d’organització i funcionament del centre.</li>
          <li>Complir amb el deure bàsic de l’estudi i de l’assistència regular i puntual a les activitats acadèmiques, i fer les tasques encomanades a casa pel professorat.</li>
          <li>Tenir sempre el material escolar necessari pel treball a l’Institut.</li>
          <li>Atendre les peticions d’entrevista o de comunicació que formuli el tutor/a o qualsevol membre de l’equip de professors.</li>
          <li>Signar la baixa si, o bé no hi ha evolució en el procés d’ensenyament-aprenentatge, o bé aquesta evolució no és positiva, o bé no es compleix algun, o alguns, dels compromisos que signa l’alumne/a.</li>

        </ol>


      <p>
        <input type="checkbox" id="authCompromis" name="authCompromis" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
          Perquè així consti, signem aquesta carta de compromís educatiu.
        <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
      </p>

    </div>
  </div>

    <br />
  </>)
}

export const AuthCompromisMenors16 = ({ auth, handleChange, error, enguany, anyVinent }) => {
  return (<>
  <div className="row">
    <div className="col col-12 ">
      <h4>
      Carta de compromís educatiu: Alumnat menors 16 anys complerts. Curs {enguany}-{anyVinent}
      </h4>

      <p>Conscients que l’educació dels joves implica l’acció conjunta de la família i de l’institut, signem aquesta carta de compromís educatiu, la qual comporta els següents COMPROMISOS:</p>

      <h5>
      Per part del centre:
      </h5>

        <ol>
            <li>Proporcionar una formació que contribueixi al desenvolupament integral de la personalitat de l’alumne/a.</li>
            <li>Fer respectar els drets de l’alumne/a en l’àmbit escolar.</li>
            <li>Educar en la línia del respecte a un mateix, el respecte als altres i el respecte a l’entorn.</li>
            <li>Informar la família del projecte educatiu i de les normes d’organització i funcionament del centre.</li>
            <li>Informar la família i l’alumne/a dels criteris que s’aplicaran per avaluar el rendiment acadèmic, fer-ne una valoració objectiva i, si escau, explicar a la família els resultats de les avaluacions.</li>
            <li>Adoptar les mesures educatives alternatives o complementàries adients, dins les possibilitats del centre, per atendre les necessitats específiques de l’alumne/a i mantenir-ne informada la família.</li>
            <li>Mantenir comunicació regular amb la família per informar-la de l’evolució acadèmica personal de l’alumne/a.</li>
            <li>Comunicar a la família les absències no justificades de l’alumne/a al centre, i qualsevol altra circumstància que sigui relevant per al seu desenvolupament acadèmic i personal.</li>
            <li>Atendre en un termini raonable les peticions d’entrevista o de comunicació que formuli la família.</li>
            <li>Revisar conjuntament amb la família el compliment d’aquests compromisos i, si escau, el seu contingut.</li>
        </ol>

      <h5>
      Per part de la família:
      </h5>

        <ol>
              <li>Respectar el caràcter propi del centre i reconèixer l’autoritat del professorat i la de l’equip directiu.</li>
              <li>Compartir amb el centre l’educació del fill/a i desenvolupar i afavorir les complicitats que són necessàries per aplicar el projecte educatiu del centre.</li>
              <li>Instar el fill o filla a respectar les normes específiques de funcionament del centre, en particular, les que afecten a la convivència escolar i el desenvolupament normal de les classes.</li>
              <li>Acceptar l’establiment de mesures correctores en cas d’incompliment tal i com figuren a les normes d’organització i funcionament del centre.</li>
              <li>Vetllar perquè el fill/a compleixi el deure bàsic de l’estudi i de l’assistència regular i puntual a les activitats acadèmiques, i també perquè faci les tasques encomanades a casa pel professorat.</li>
              <li>Ajudar el nostre fill o filla a organitzar el temps d’estudi a casa i a preparar el material per a l’activitat escolar. També haurem de procurar que tingui sempre el material escolar necessari pel treball a l’Institut.</li>
              <li>Adoptar criteris i mesures que puguin afavorir el rendiment escolar del fill o filla.</li>
              <li>Adreçar-se directament al centre per contrastar les discrepàncies, coincidències o suggeriments en relació amb l’aplicació del projecte educatiu en la formació del fill o filla.</li>
              <li>Facilitar al centre les informacions del fill o filla que siguin rellevants per al procés d’aprenentatge.</li>
              <li>Atendre les peticions d’entrevista o de comunicació que formuli el centre.</li>
              <li>Informar el fill o filla del contingut d’aquests compromisos.</li>
              <li>Responsabilitzar-se d’assistir a totes les reunions individuals i col·lectives convocades pel centre.</li>
              <li>Acceptar el compliment de sancions en un temps extraordinari fora de l’horari lectiu. L’incompliment d’aquest punt pot comportar l’apertura d’un procediment sancionador que pot anar de 3 a 20 dies lectius.</li>
              <li>Revisar conjuntament amb el centre educatiu el compliment dels compromisos de la carta.</li>
        </ol>


      <p>
        <input type="checkbox" id="authCompromis" name="authCompromis" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
          <label htmlFor="authCompromis">Perquè així consti, signem aquesta carta de compromís educatiu.</label>
        <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
      </p>

    </div>
  </div>

    <br />
  </>)
}
